import { render, staticRenderFns } from "./UserViewAccountDetail.vue?vue&type=template&id=5cb47071&v-if=userData&"
import script from "./UserViewAccountDetail.vue?vue&type=script&lang=js&"
export * from "./UserViewAccountDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserViewAccountDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports